// DialogSubscriptionUpgrade Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Dialog from '../../layout/dialog/dialog.jsx'
import Button from '../../common/button/button.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'

class DialogSubscriptionUpgrade extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: props.active
    }
  }

  static get propTypes () {
    return {
      active: PropTypes.bool,
      isTeamTrail: PropTypes.bool,
      onUpgrade: PropTypes.func
    }
  }

  static get defaultProps () {
    return {
      active: false,
      isTeamTrail: false,
      onUpgrade: null
    }
  }

  show () {
    FabButtonManager.setVisible(false)
    this.setState({ active: true })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({ active: false })
  }

  render () {
    const { isTeamTrail } = this.props
    const title = `setting.subscription.upgradeTitle${
      isTeamTrail ? 'Trial' : 'Paid'
    }`
    const info = `setting.subscription.upgradeInfo${
      isTeamTrail ? 'Trial' : 'Paid'
    }`
    return (
      <Dialog active={this.state.active} modal={false}>
        <div className='dialog-subscriptionupgrade'>
          <div className='iconbar'>
            <IconButton
              icon='dialog-warning'
              className='modal popupalert'
              canHover={false}
            />
          </div>
          <div className='paymentcont'>
            <div className='section'>
              <div className='title'>
                <IntlMessage ident={title} />
              </div>
              <div className='info'>
                <IntlMessage ident={info} />
              </div>
            </div>
          </div>
          <div className='paymentact'>
            <Button
              title='setting.subscription.actionUpgrade'
              icon='common-success-tick'
              className='upgrade'
              canHover={false}
              onClick={() => this.props.onUpgrade()}
            />
          </div>
        </div>
      </Dialog>
    )
  }
}

export default DialogSubscriptionUpgrade
